import i18n from "i18n";
import { ContentManagementTabConfig } from "../contentManagementTypes";

import TagsTab from "../contentManagementComponents/TagsTab";
import UpdatesTab from "../contentManagementComponents/UpdatesTab";
import ViolationsTab from "../contentManagementComponents/ViolationsTab";
import SeriousOffenseReasonsTab from "../contentManagementComponents/SeriousOffenseReasonsTab";
import TextSuggestionsTab from "../contentManagementComponents/TextSuggestionsTab";
import UsersCharacteristicTab from "../contentManagementComponents/UsersCharacteristicTab";
import RejectionReasonsTab from "../contentManagementComponents/RejectionReasonsTab";

const TIME_ZONE = 3; // Offset in hours (e.g., 3 for Israel Daylight Time)

export const CONTENT_MANAGEMENT_TABS: ContentManagementTabConfig[] = [
  {
    tabName: "tags",
    tabTitle: i18n.t("תגיות"),
    tabComponent: TagsTab,
  },
  {
    tabName: "updates",
    tabTitle: i18n.t("ידיעות"),
    tabComponent: UpdatesTab,
  },
  {
    tabName: "violations",
    tabTitle: i18n.t("סוגי עבירות"),
    tabComponent: ViolationsTab,
  },
  {
    tabName: "seriousOffense",
    tabTitle: i18n.t("סיבות עבירה חמורה"),
    tabComponent: SeriousOffenseReasonsTab,
  },
  {
    tabName: "textSuggestions",
    tabTitle: i18n.t("הצעות טקסט"),
    tabComponent: TextSuggestionsTab,
  },
  {
    tabName: "usersCharacteristic",
    tabTitle: i18n.t("אפיון משתמשים"),
    tabComponent: UsersCharacteristicTab,
  },
  {
    tabName: "rejectionReasons",
    tabTitle: i18n.t("סיבות פסילה"),
    tabComponent: RejectionReasonsTab,
  },
];

// return string in format of yyyy-mm-ddThh:mm:ss => "2023-06-09T00:00:00"
export const getAdjustedISOString = (date: Date) => {
  const adjustedDate = new Date(
    new Date(date).getTime() + TIME_ZONE * 60 * 60 * 1000
  );
  const adjustedISOString = adjustedDate.toISOString();
  return adjustedISOString;
};

// return format of dd.m.yyyy, hh:mm => 12.6.2023, 13:55
export const getFormattedDateAndTime = (stringDate: string | Date) => {
  const date = new Date(stringDate);

  const formatted = Intl.DateTimeFormat("he-IS", {
    dateStyle: "short",
    timeStyle: "short",
    timeZone: "Asia/Jerusalem",
  }).format(date);
  return formatted;
};
